import React from 'react';
import { MetaNavItem } from './meta-nav-item';
import { useNavigation } from '../context/navigation-context-provider';
import { useTranslation } from 'next-i18next';

export const MetaNavSection = () => {
  const { t } = useTranslation();
  const { config } = useNavigation();
  return (
    <nav
      className="flex gap-x-6 border-r border-secondary pl-2 pr-8"
      data-testid="navigation_metanavigation"
      aria-label={t('shared:shared_globalNav_meta_aria_label')}
    >
      {config.metaNavItems?.map((item) => (
        <MetaNavItem key={item.id} item={item} />
      ))}
    </nav>
  );
};
